export default "__VITE_ASSET__hl4PGiqN__"